import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {LatestOrderPhotoGroupType, ServiceRequestWorkflowStatus} from '../../unit-card/image-group.model';

export interface LightBoxImageType {
  imageType: LatestOrderPhotoGroupType;
  imageLink: string;
  end_user_id: number;
  end_user_login: string;
  end_user_order_id: number;
  order_start_time: number;
  order_finish_time: number;
  service_request_workflow_status: ServiceRequestWorkflowStatus;
  service_request_timestamp: number;
}

@Injectable({
  providedIn: 'root'
})
export class OrderPhotosLightboxService {
  selectedImageIndex: BehaviorSubject<number> = new BehaviorSubject(null);
  images: BehaviorSubject<LightBoxImageType[]> = new BehaviorSubject([]);
  show: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showArrow: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showSwitchButton: BehaviorSubject<boolean> = new BehaviorSubject(false);
  arrowClicked: BehaviorSubject<string> = new BehaviorSubject(null);
  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
  }

  open(images: LightBoxImageType[], index = 0, showArrowsAnyway = false, showSwitchButton = true) {
    this.images.next(images);
    this.selectedImageIndex.next(index);
    this.show.next(true);
    this.showSwitchButton.next(showSwitchButton);
    if (images.length > 1 || showArrowsAnyway) {
      this.showArrow.next(true);
    } else {
      this.showArrow.next(false);
    }
  }

  clickSwitchButton(i) {
    this.selectedImageIndex.next(i);
  }

  iterateImage(eventName) {
    if (eventName === 'next') {
      const indexNext = this.selectedImageIndex.value + 1;
      if (indexNext >= this.images.value.length) {
        this.selectedImageIndex.next(0);
      } else {
        this.selectedImageIndex.next(indexNext);
      }
    }
    if (eventName === 'previous') {
      const indexPrev = this.selectedImageIndex.value - 1;
      if (indexPrev < 0) {
        this.selectedImageIndex.next(this.images.value.length - 1);
      } else {
        this.selectedImageIndex.next(indexPrev);
      }
    }
    this.arrowClicked.next(eventName);
  }
}
